import { render } from "./OTPVerificationModal.vue?vue&type=template&id=1875512b&scoped=true"
import script from "./OTPVerificationModal.vue?vue&type=script&lang=js"
export * from "./OTPVerificationModal.vue?vue&type=script&lang=js"

import "./OTPVerificationModal.vue?vue&type=style&index=0&id=1875512b&scoped=true&lang=css"

import exportComponent from "/home/runner/work/acp-portal-frontend/acp-portal-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1875512b"]])

export default __exports__